// palette
/** @type Record<string, string> */
const colors = {
  blue: '#005091',
  red: '#ea0100',
  rxGreen: '#34cb9e',
  dark: '#444',
  grey: '#adadad',
  greyLight: '#dadada',
  // FIXME Decide to use “sky” as prefix _or_ suffix
  greySky: '#efefef',
  skyBlue: '#e6edf3',
  redLightBackground: '#fce5e5',
  greenLight: '#e6f5eb',
  rebrandingRed: '#E90033',
}

// semantic
colors.background = '#fff'
colors.positive = '#093'
colors.warning = '#f6bb14'
colors.attention = '#ff8a00'
colors.negative = colors.red
colors.info = colors.blue
colors.star = '#ffd201'
colors.yellowStar = '#FDE25B'
colors.now = colors.positive
colors.aboLabelBg = '#f5f8fb'

// platforms
Object.assign(colors, {
  twitter: '#55acee',
  pinterest: '#bd081c',
  google: '#d34836',
  whatsapp: '#25d366',
  facebook: '#3a5a98',
  youtube: '#f00',
})

module.exports = colors
